import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FleetApiService } from 'src/app/services/api/fleet-api.service';

@Component({
  selector: 'app-fleet-node-modal',
  templateUrl: './fleet-node-modal.component.html',
  styleUrls: ['./fleet-node-modal.component.scss'],
})
export class FleetNodeModalComponent implements OnInit {
  list = [{ id: 1, name: '节点一', time: '0.9s', check: false }];

  constructor(
    private api: FleetApiService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.findNodes();
  }

  checkNode(id: number) {
    this.list.forEach((item) => {
      item.check = item.id === id;
    });
  }

  onOk() {}

  loading = false;
  async findNodes() {
    try {
      this.loading = true;
      const r = await this.api.findNodes(
        this.data.access,
        this.data.current,
        this.data.Authorization
      );
      this.list = r.data.list;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
